import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67e14145&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=67e14145&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e14145",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e14145')) {
      api.createRecord('67e14145', component.options)
    } else {
      api.reload('67e14145', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67e14145&scoped=true", function () {
      api.rerender('67e14145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/community/config/index.vue"
export default component.exports